/* Homepage editorial motion. Independent from carousel and product interactions. */
(() => {
 'use strict';
 const boot = () => {
  const g=window.gsap, ST=window.ScrollTrigger, hero=document.querySelector('#top.xuk-hero');
  if(!g||!ST||!hero)return;
  g.registerPlugin(ST);
  const mm=g.matchMedia();
  const diagnostics=window.xukEditorialMotion={version:'1.0',sections:[],opening:null};
  mm.add({reduce:'(prefers-reduced-motion: reduce)',mobile:'(max-width: 749px)',tablet:'(min-width: 750px) and (max-width: 989px)',desktop:'(min-width: 990px)'},ctx=>{
   diagnostics.sections=[];
   if(ctx.conditions.reduce){diagnostics.mode='reduced';return;}
   diagnostics.mode='animated';
   const mobile=ctx.conditions.mobile;
   const wrapper=document.querySelector('.page-wrapper');
   const scroller=wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) && wrapper.scrollHeight>wrapper.clientHeight+2 ? wrapper : window;
   const scrollOptions={scroller};
   diagnostics.scroller=scroller===window?'window':'.page-wrapper';
   const done={clearProps:'transform,clipPath,willChange'};
   const heading=hero.querySelector('h1');
   const opening=g.timeline({defaults:{ease:'expo.out'},onComplete:()=>{diagnostics.openingDone=true;}});
   diagnostics.opening=opening;
   diagnostics.openingDone=false;
   opening.addLabel('reveal',0)
    .fromTo(heading,{clipPath:'inset(100% 0% 0% 0%)',y:mobile?60:105,scaleY:.68,transformOrigin:'50% 100%'},{clipPath:'inset(-6% -3% -6% -3%)',y:0,scaleY:1,duration:1.85,...done},.12)
    .fromTo(hero.querySelector('.xuk-eyebrow'),{clipPath:'inset(0 100% 0 0)'},{clipPath:'inset(0 0% 0 0)',duration:1.3,clearProps:'clipPath'},.05)
    .fromTo(hero.querySelector('.xuk-hero__product-media'),{clipPath:'inset(0 0 100% 0)',y:mobile?26:55},{clipPath:'inset(0 0 0% 0)',y:0,duration:1.85,...done},.48)
    .fromTo(hero.querySelector('.xuk-hero__description'),{clipPath:'inset(100% 0 0 0)',y:28},{clipPath:'inset(0% 0 0 0)',y:0,duration:1.25,...done},1.02)
    .fromTo(hero.querySelectorAll('.xuk-hero__actions > a'),{clipPath:'inset(0 100% 0 0)',y:18},{clipPath:'inset(0 0% 0 0)',y:0,duration:1.15,stagger:.15,...done},1.32)
    .fromTo(hero.querySelector('.xuk-hero__product-copy'),{clipPath:'inset(100% 0 0 0)',y:16},{clipPath:'inset(0% 0 0 0)',y:0,duration:1.15,...done},1.35);
   // Returning via anchor or browser scroll restoration must not replay off-screen intro.
   if(window.scrollY>hero.offsetHeight*.65)opening.progress(1);
   // One visual role per section. Reading content stays present.
   const specs=[
    {selector:'#xuk-preventive',target:'.pi-media',kind:'lift'},
    {selector:'#ecosystem',target:'.xuk-ecosystem__media',kind:'lift'},
    {selector:'#popular-products',target:'h2',kind:'title'},
    {selector:'#smart-home',target:'.sh-scene',kind:'house'},
    {selector:'#solutions',target:'.xuk-safety-solutions__media',kind:'lift'},
    {selector:'#app-connectivity',target:'.cp-product',kind:'lift'},
    {selector:'#business',target:'.xuk-for-business__media',kind:'wipe'},
    {selector:'.xuk-factory',target:'.xuk-factory__media--primary',kind:'wipe'},
    {selector:'#xuk-dual',target:'.fd-product',kind:'lift'}
   ];
   specs.forEach(({selector,target,kind},index)=>{
    const root=document.querySelector(selector);if(!root)return;
    const els=[...root.querySelectorAll(target)].filter(e=>e.getClientRects().length);
    if(!els.length)return;
    const tl=g.timeline({defaults:{ease:'power3.out'},scrollTrigger:{...scrollOptions,id:'editorial-'+index,trigger:els[0],start:'top 92%',once:true}});
    if(kind==='house'){
     // Scene moves as one plane: house and hotspots always remain aligned.
     tl.fromTo(els,{y:mobile?12:26,scale:mobile?.99:.975},{y:0,scale:1,duration:1.55,...done},0);
     const points=[...root.querySelectorAll('.sh-pin i')];
     tl.fromTo(points,{scale:.4},{scale:1,duration:.65,stagger:.09,clearProps:'transform'},.48);
    }else if(kind==='title'){
     tl.fromTo(els,{y:mobile?18:30,clipPath:'inset(100% 0 0 0)'},{y:0,clipPath:'inset(-5% 0 -5% 0)',duration:1.1,...done});
    }else if(kind==='wipe'){
     tl.fromTo(els,{clipPath:'inset(0 12% 0 0)'},{clipPath:'inset(0 0% 0 0)',duration:1.35,clearProps:'clipPath'});
    }else{
     tl.fromTo(els,{y:mobile?10:18},{y:0,duration:1.05,stagger:.07,...done});
    }
    diagnostics.sections.push({selector,headings:kind==='title'?1:0,cards:0,media:els.length,timeline:tl,kind});
   });
   const refresh=()=>ST.refresh();
   document.fonts?.ready.then(refresh);
   window.addEventListener('load',refresh,{once:true});
   const onFocus=e=>{const entry=diagnostics.sections.find(x=>e.target.closest(x.selector));if(entry)entry.timeline.progress(1);};
   document.addEventListener('focusin',onFocus);
   return()=>{window.removeEventListener('load',refresh);document.removeEventListener('focusin',onFocus);};
  });
  window.addEventListener('pagehide',()=>mm.revert(),{once:true});
  window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
